const cards = [
  {
    key: "needs_attention",
    label: "Precisa de atuação",
    summaryKey: "needsAttention",
  },
  { key: "on_track", label: "No caminho", summaryKey: "onTrack" },
  { key: "critical", label: "Críticas", summaryKey: "critical" },
  {
    key: "no_measurement",
    label: "Sem medição",
    summaryKey: "noMeasurement",
  },
];

const ScheduleSummary = ({ summary = {}, activeStatus, onStatus }) => (
  <div className="schedule-summary" aria-label="Resumo do cronograma">
    {cards.map((card) => (
      <button
        type="button"
        key={card.key}
        className={`schedule-summary-card ${activeStatus === card.key ? "active" : ""}`}
        aria-pressed={activeStatus === card.key}
        onClick={() => onStatus(card.key)}
      >
        <span>{card.label}</span>
        <strong>{summary[card.summaryKey] ?? 0}</strong>
      </button>
    ))}
  </div>
);

export default ScheduleSummary;
